import React from "react";
import * as RadioGroup from "@radix-ui/react-radio-group";
import { RadioButtonGroupProps } from "./types";
import { RadioButton } from "./RadioButton";
import { optionsWrapperClass } from "./RadioButtonGroup.css";
import { getDir } from "@learningblocks/shared-components/lib/Translations";
import { useIntl } from "react-intl";

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  options,
  selectedOptionIndex,
  submittedOptionIndexes = [],
  answerId,
  onOptionSelect,
  ariaLabelledby,
  showFeedbackOnSubmit = true,
  disabled = false,
  idPrefix,
}) => {
  const charCodeA = "A".charCodeAt(0);

  const handleValueChange = (value: string) => {
    onOptionSelect?.(parseInt(value, 10));
  };

  // The slice preserves `selected` across submit, so binding the group value
  // directly to `selectedOptionIndex` keeps the submitted option exposed as
  // aria-checked="true" and lets a re-click of the same option re-fire cleanly.
  const intl = useIntl();
  return (
    <RadioGroup.Root
      className={optionsWrapperClass}
      value={
        selectedOptionIndex !== undefined ? selectedOptionIndex.toString() : ""
      }
      onValueChange={handleValueChange}
      aria-labelledby={ariaLabelledby}
      dir={getDir(intl.locale)}
      disabled={disabled}
    >
      {options.map((option, index) => {
        const isCorrect = answerId.includes(option.id);
        return (
          <RadioButton
            key={option.id}
            option={option}
            displayLabel={String.fromCharCode(charCodeA + index)}
            isSelected={selectedOptionIndex === option.id}
            isSubmitted={submittedOptionIndexes.includes(option.id)}
            isCorrect={isCorrect}
            showFeedbackOnSubmit={showFeedbackOnSubmit}
            idPrefix={idPrefix}
          />
        );
      })}
    </RadioGroup.Root>
  );
};

export default RadioButtonGroup;
